module.exports = __webpack_public_path__ + "img/close_hint_m.e9590e65.svg";